import PageHero from "@/components/jf/PageHero";
import Ambaari from "@/components/jf/Ambaari";
import Reveal from "@/components/jf/Reveal";
import { useGo } from "@/components/jf/Nav";

const FACTS = [
  {
    t: "A New Factory",
    d: "A larger, state-of-the-art facility is being built to craft AMBAARI at scale — without losing the handmade soul.",
  },
  {
    t: "A Dedicated E-Commerce",
    d: "AMBAARI will launch with its own online store, bringing Jaipur's craftsmanship to doorsteps across India.",
  },
  {
    t: "The Same Promise",
    d: "Solid wood, honest craft and furniture built to last generations — the house standard continues.",
  },
];

export default function AmbaariPage() {
  const go = useGo();
  return (
    <main>
      <PageHero
        kicker="Coming Soon"
        title={<>A new chapter is <em className="text-brass-soft font-light">being carved.</em></>}
        accent="A"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          From the House of Jaipur Furniture — a new brand, a new factory, and a whole new way
          to bring Jaipur home.
        </p>
      </PageHero>

      <Ambaari />

      <section data-testid="ambaari-facts" className="bg-ivory py-24 md:py-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-3 gap-6">
            {FACTS.map((f, i) => (
              <Reveal key={f.t} delay={i * 0.07}>
                <div
                  data-testid={`ambaari-fact-${i}`}
                  className="border border-oxblood/20 p-10 h-full hover:border-brass/70 transition-colors duration-500"
                >
                  <span className="font-display text-brass text-3xl">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-6 font-display text-oxblood-ink text-2xl">{f.t}</h3>
                  <p className="mt-4 text-ink/60 font-light text-sm leading-relaxed">{f.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <div className="text-center mt-16">
              <p className="text-ink/55 font-light text-sm mb-8">
                Until AMBAARI arrives, the house collection is open for booking.
              </p>
              <button
                data-testid="ambaari-book-btn"
                onClick={() => go("book")}
                className="bg-oxblood text-ivory hover:bg-oxblood-ink px-10 py-4 text-xs tracking-[0.28em] uppercase transition-colors duration-400"
              >
                Book Jaipur Furniture
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
